import { useEffect, useState } from 'react';

/** Кнопка с подтверждением вторым нажатием (как в прототипе). */
export function ConfirmButton({
  label,
  confirmLabel,
  onConfirm,
  disabled,
  quiet = false,
}: {
  label: string;
  confirmLabel: string;
  onConfirm: () => void;
  disabled?: boolean;
  quiet?: boolean;
}) {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const id = window.setTimeout(() => setArmed(false), 5000);
    return () => window.clearTimeout(id);
  }, [armed]);
  return (
    <button
      type="button"
      className={`btn ${armed ? 'btn-primary' : quiet ? 'btn-quiet' : ''}`}
      disabled={disabled}
      onClick={() => {
        if (!armed) return setArmed(true);
        setArmed(false);
        onConfirm();
      }}
    >
      {armed ? confirmLabel : label}
    </button>
  );
}
